// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `simple-modal .simple-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  pointer-events: auto;
}
simple-modal .simple-modal .page-overlay {
  background-color: var(--motes-black);
  opacity: 0.8;
  height: inherit;
  width: inherit;
}
simple-modal .simple-modal .page-overlay.disabled {
  pointer-events: none;
}
simple-modal .simple-modal .modal-window {
  position: absolute;
  width: calc(100% - 50px);
  max-width: 800px;
  text-align: center;
  text-align: center;
  border-radius: var(--border-radius);
  box-sizing: border-box;
  margin: var(--motes-padding) 0;
  padding: 0px;
}
simple-modal .simple-modal .modal-window.light-bg {
  background-color: var(--motes-off-white);
}
simple-modal .simple-modal .modal-window .content {
  margin: var(--mega-spacing);
}
simple-modal .simple-modal .modal-window .modal-description {
  text-align: left;
}
simple-modal .simple-modal .modal-window .select-buttons {
  margin-top: var(--motes-padding);
  grid-template-columns: 1fr;
  display: grid;
  column-gap: var(--small-spacing);
}
simple-modal .simple-modal .modal-window .select-buttons.two-buttons {
  grid-template-columns: repeat(2, 1fr);
}
simple-modal .simple-modal .modal-window .select-buttons button {
  margin: 0;
  width: 100%;
}
@media all and (max-width: 600px) {
  simple-modal .simple-modal .modal-window .content {
    margin: var(--large-spacing);
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/simple-modal/simple-modal.component.scss"],"names":[],"mappings":"AAEI;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;AADR;AAGQ;EACI,oCAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AADZ;AAGY;EACI,oBAAA;AADhB;AAKQ;EACI,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mCAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AAHZ;AAKY;EACI,wCAAA;AAHhB;AAMY;EACI,2BAAA;AAJhB;AAOY;EACI,gBAAA;AALhB;AAQY;EACI,gCAAA;EACA,0BAAA;EACA,aAAA;EACA,gCAAA;AANhB;AAQgB;EACI,qCAAA;AANpB;AASgB;EACI,SAAA;EACA,WAAA;AAPpB;AAYQ;EAEQ;IACI,4BAAA;EAXlB;AACF","sourcesContent":["simple-modal {\n\n    .simple-modal {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        z-index: 50; // Root-level modal elements should have z-indices ranging between 50 and 59: https://docs.storyhunt.dk/dev/creator/style-guide.html\n        pointer-events: auto;\n\n        .page-overlay {\n            background-color: var(--motes-black);\n            opacity: 0.8;\n            height: inherit;\n            width: inherit;\n\n            &.disabled {\n                pointer-events: none;\n            }\n        }\n\n        .modal-window {\n            position: absolute;\n            width: calc(100% - 50px);\n            max-width: 800px;\n            text-align: center;\n            text-align: center;\n            border-radius: var(--border-radius);\n            box-sizing: border-box;\n            margin: var(--motes-padding) 0;\n            padding: 0px;\n\n            &.light-bg {\n                background-color: var(--motes-off-white);\n            }\n\n            .content {\n                margin: var(--mega-spacing);\n            }\n\n            .modal-description {\n                text-align: left;\n            }\n\n            .select-buttons {\n                margin-top: var(--motes-padding);\n                grid-template-columns: 1fr;\n                display: grid;\n                column-gap: var(--small-spacing);\n\n                &.two-buttons {\n                    grid-template-columns: repeat(2, 1fr);\n                }\n\n                button {\n                    margin: 0;\n                    width: 100%;\n                }\n            }\n        }\n\n        @media all and (max-width: 600px) {\n            .modal-window {\n                .content {\n                    margin: var(--large-spacing);\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
